var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bg-page"},[_c('div',{staticClass:"tips"},[_vm._v(" 您要访问的页面并不存在哦！即将放回上一页 ")])])
}]

export { render, staticRenderFns }